.base {
  display: block;
  background-color: var(--color-background-placeholder);
  width: 100%;
  height: auto;
}
